import { render, staticRenderFns } from "./PlanosPagamentos.vue?vue&type=template&id=0c3c6874"
import script from "./PlanosPagamentos.vue?vue&type=script&lang=js"
export * from "./PlanosPagamentos.vue?vue&type=script&lang=js"
import style0 from "./PlanosPagamentos.vue?vue&type=style&index=0&id=0c3c6874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports